import * as React from 'react';
import { Box } from '@material-ui/core';
import { Form, Formik, FormikHelpers } from 'formik';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router';
import toast from 'react-hot-toast';

import { FormikTextField } from '@components/fieldBindings/FormikTextField';
import { FormikSubmitButton } from '@components/fieldBindings/FormikSubmitButton';
import { RouteNames } from '@constants/RouteNames';
import client from '@api/client';
import i18n from '@src/i18n';
import { CenterColumnPage } from '../../Layouts/CenterColumnPage/CenterColumnPage';

type AdminLoginFormValues = {
  adminPassword: string;
};

const validationSchema = Yup.object().shape({
  adminPassword: Yup.string().required(i18n.t('common.required')),
});

export const AdminLogin: React.FC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const redirect = new URLSearchParams(location.search).get('redirect');

  const handleSubmit = async (
    { adminPassword }: AdminLoginFormValues,
    util: FormikHelpers<AdminLoginFormValues>
  ) => {
    try {
      await client.adminLogin(adminPassword);
      history.push(redirect || RouteNames.ADMIN_USERS);
    } catch (err) {
      toast.error(t('pages.adminLogin.errorMsg') as string);
      util.setSubmitting(false);
    }
  };

  return (
    <CenterColumnPage pageTitle={t('pages.adminLogin.titleText') as string}>
      <Formik<AdminLoginFormValues>
        onSubmit={handleSubmit}
        initialValues={{ adminPassword: '' }}
        validateOnBlur={false}
        validationSchema={validationSchema}
      >
        {({ isValid, dirty }) => (
          <Form>
            <Box display="flex" flexDirection="column" mb={2}>
              <FormikTextField
                id="adminPassword"
                name="adminPassword"
                type="password"
                placeholder={t('pages.adminLogin.adminPassword.placeholder')}
                margin="normal"
                autoComplete="off"
                autoFocus
              />
            </Box>
            <FormikSubmitButton disabled={!(isValid && dirty)}>
              {t('pages.adminLogin.submitButtonText')}
            </FormikSubmitButton>
          </Form>
        )}
      </Formik>
    </CenterColumnPage>
  );
};

export default AdminLogin;
